import { IndexableType } from 'dexie'
import { Locations } from '../../../services/globalIndexDb.service'
import { call } from 'redux-saga/effects'
import { LocationService } from '../../../services/locations.service'
import { GlobalDataMetadataService } from '../../../services/globalDataMetadata.service'
import { IGlobalDataResponseDoc } from '../services/globalDataImport.service'
import Logger from '../../../services/logger.service'

export function* setLocationsData(globalDataResponseDoc: IGlobalDataResponseDoc) {
  try {
    const locationService = new LocationService()
    const globalDataMetadataService = new GlobalDataMetadataService()

    const globalDataJSON: { entity: Locations } = JSON.parse(globalDataResponseDoc.docData)
    if (globalDataJSON.entity && globalDataJSON.entity.length > 0) {
      const stateId = globalDataResponseDoc.id.split('location_')[1]
      if (stateId) {
        // Each globalDataJSON entity has location data for a particular state,
        // get all the keys that belong to that state being updated and delete the keys that do not exist in the updated result.
        const locationKeysPerStateArray: string[] = yield call(
          [locationService, locationService.getLocationPrimaryKeysPerState],
          stateId.toUpperCase()
        )
        const entityKeySet = new Set(globalDataJSON.entity.map((location) => location.id))
        const keysToDelete = locationKeysPerStateArray.filter((key) => !entityKeySet.has(key))
        if (keysToDelete && keysToDelete.length > 0) {
          yield call([locationService, locationService.deleteAllLocationsData], keysToDelete)
        }
      }

      const crudResponse: IndexableType = yield call(
        [locationService, locationService.createOrUpdateAllLocationsData],
        globalDataJSON.entity
      )
      if (crudResponse) {
        // Add this to metadata table only after the CRUD is success
        yield call([globalDataMetadataService, globalDataMetadataService.createOrUpdate], globalDataResponseDoc)
      }
    }
  } catch (error) {
    Logger.error(`Error setting location data for doc', ${globalDataResponseDoc?.id}, cause ${error}`)
  }
}
